const BASE_PORTAL_ADMIN_TOOLS = [
  {
    key: "dashboard",
    icon: "🏠",
    label: "Dashboard",
    title: "Dashboard",
    description: "View key platform stats and management tools",
    path: "/portal-admin",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "platform-settings",
    icon: "⚙️",
    label: "Platform Settings",
    title: "Platform Settings",
    description:
      "Configure platform fees, trial periods, and revenue distribution",
    path: "/portal-admin/settings",
    color: "#3b82f6",
    bgColor: "#eff6ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "theme-settings",
    icon: "🎨",
    label: "Theme Settings",
    title: "Theme Settings",
    description: "Customize fonts, colors, and typography across the platform",
    path: "/portal-admin/theme",
    color: "#8b5cf6",
    bgColor: "#f5f3ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "email-senders",
    icon: "📧",
    label: "Email Senders",
    title: "Email Senders",
    description: "Manage trusted sender identities and outbound email settings",
    path: "/portal-admin/email-senders",
    color: "#ec4899",
    bgColor: "#fdf2f8",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "professional-types",
    icon: "💼",
    label: "Professional Types",
    title: "Professional Types",
    description: "Manage professional roles and specializations",
    path: "/portal-admin/professional-types",
    color: "#f59e0b",
    bgColor: "#fffbeb",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "business-categories",
    icon: "🏢",
    label: "Business Categories",
    title: "Business Categories",
    description: "Configure business types and category settings",
    path: "/portal-admin/business-categories",
    color: "#06b6d4",
    bgColor: "#ecfeff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "product-categories",
    icon: "📦",
    label: "Product Categories",
    title: "Product Categories",
    description: "Manage product categories across all shops",
    path: "/portal-admin/product-categories",
    color: "#0ea5e9",
    bgColor: "#f0f9ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "service-categories",
    icon: "📂",
    label: "Service Categories",
    title: "Service Categories",
    description: "Organize services by category for each business type",
    path: "/portal-admin/service-categories",
    color: "#14b8a6",
    bgColor: "#f0fdfa",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "service-templates",
    icon: "✨",
    label: "Service Templates",
    title: "Service Templates",
    description: "Create reusable service templates for teams and shops",
    path: "/portal-admin/service-templates",
    color: "#6366f1",
    bgColor: "#eef2ff",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "business-management",
    icon: "🏬",
    label: "Business Management",
    title: "Business Management",
    description: "Manage business accounts and subscriptions",
    path: "/portal-admin/businesses",
    color: "#0891b2",
    bgColor: "#ecfeff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "support-migration",
    icon: "🛟",
    label: "Migration Help",
    title: "Support-assisted migration",
    description: "Import a new shop's data for them during onboarding",
    path: "/portal-admin/support-migration",
    color: "#0f766e",
    bgColor: "#ecfdf5",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "user-management",
    icon: "👥",
    label: "User Management",
    title: "User Management",
    description: "View, edit, and manage all platform users",
    path: "/portal-admin/users",
    color: "#8b5cf6",
    bgColor: "#f5f3ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "support-agents",
    icon: "🛎️",
    label: "Support Agents",
    title: "Support Agents",
    description: "Dedicated R6 flow for onboarding and managing R8 support agents",
    path: "/portal-admin/support-agents",
    color: "#0ea5e9",
    bgColor: "#f0f9ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "referral-agents",
    icon: "🤝",
    label: "Promos & Referrals",
    title: "Promos & Referrals",
    description: "Create signup promo codes and approve R9 referral agents",
    path: "/portal-admin/referral-agents",
    color: "#7c3aed",
    bgColor: "#f5f3ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "guest-leads",
    icon: "📧",
    label: "Guest Leads",
    title: "Guest Leads",
    description: "Review and manage guest leads captured across the platform",
    path: "/portal-admin/leads",
    color: "#a855f7",
    bgColor: "#faf5ff",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "country-waitlist",
    icon: "🌍",
    label: "Country Waitlist",
    title: "Country Waitlist",
    description: "Track regional demand and manage country waitlist requests",
    path: "/portal-admin/country-waitlist",
    color: "#16a34a",
    bgColor: "#f0fdf4",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "marketing",
    icon: "📨",
    label: "Marketing",
    title: "Marketing",
    description: "Manage platform campaigns and communication workflows",
    path: "/portal-admin/marketing",
    color: "#0ea5e9",
    bgColor: "#f0f9ff",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "looks",
    icon: "📸",
    label: "Looks",
    title: "Looks Moderation",
    description: "Moderate user-submitted looks and platform media content",
    path: "/portal-admin/looks",
    color: "#db2777",
    bgColor: "#fdf2f8",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "sms-optouts",
    icon: "📵",
    label: "SMS Opt-Outs",
    title: "SMS Opt-Outs",
    description: "Manage SMS opt-out requests and compliance records",
    path: "/portal-admin/sms-optouts",
    color: "#475569",
    bgColor: "#f8fafc",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "shop-management",
    icon: "🏪",
    label: "Shop Management",
    title: "Shop Management",
    description: "Oversee all registered shops and locations",
    path: "/portal-admin/shops",
    color: "#f97316",
    bgColor: "#fff7ed",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "analytics",
    icon: "📊",
    label: "Analytics",
    title: "Platform Analytics",
    description: "View comprehensive platform statistics and reports",
    path: "/portal-admin/analytics",
    color: "#6366f1",
    bgColor: "#eef2ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "payout-schedule",
    icon: "📅",
    label: "Payout Schedule",
    title: "Payout Schedule",
    description: "Manage payout schedules and transfer timing",
    path: "/portal-admin/payout-schedule",
    color: "#0f766e",
    bgColor: "#ecfeff",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "refund-governance",
    icon: "🛡️",
    label: "Refund Governance",
    title: "Refund Governance",
    description: "Review high-risk refund requests and record admin decisions",
    path: "/portal-admin/refund-governance",
    color: "#dc2626",
    bgColor: "#fef2f2",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "product-returns",
    icon: "↩️",
    label: "Product Returns",
    title: "Product Returns",
    description: "Review, assign, decide, and execute product return refunds",
    path: "/portal-admin/product-returns",
    color: "#0ea5e9",
    bgColor: "#f0f9ff",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "frozen-packages",
    icon: "🧊",
    label: "Frozen Packages",
    title: "Frozen Packages",
    description:
      "Review a sender's freeze: release it, cancel the package, or return it to the sender",
    path: "/portal-admin/frozen-packages",
    color: "#0284c7",
    bgColor: "#e0f2fe",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "product-tax-audit",
    icon: "🧾",
    label: "Product Tax Audit",
    title: "Product Tax Audit",
    description: "Audit product booking tax metadata and payout ledger coverage",
    path: "/portal-admin/product-tax-audit",
    color: "#dc2626",
    bgColor: "#fef2f2",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "shop-tax-rates",
    icon: "🧮",
    label: "Shop Tax Rates",
    title: "Shop Pickup Tax Rates",
    description:
      "The sales-tax rate charged when a product is collected at each shop, derived from Stripe",
    path: "/portal-admin/shop-tax-rates",
    color: "#0f766e",
    bgColor: "#f0fdfa",
    showInSidebar: true,
    showInDashboard: false,
  },
  {
    key: "product-transactions",
    icon: "💳",
    label: "Product Transactions",
    title: "Product Transactions",
    description: "Review product purchase fees, payout splits, and Stripe references",
    path: "/portal-admin/product-transactions",
    color: "#0f766e",
    bgColor: "#ecfdf5",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "revenue",
    icon: "💰",
    label: "Revenue Analytics",
    title: "Revenue Analytics",
    description: "Track platform fees, payouts, and revenue streams",
    path: "/portal-admin/revenue",
    color: "#10b981",
    bgColor: "#ecfdf5",
    showInSidebar: true,
    showInDashboard: true,
  },
  {
    key: "fraud",
    icon: "🛡️",
    label: "Fraud Detection",
    title: "Fraud Detection",
    description: "Monitor suspicious activity and manage flagged accounts",
    path: "/portal-admin/fraud",
    color: "#ef4444",
    bgColor: "#fef2f2",
    available: false,
    showInSidebar: false,
    showInDashboard: true,
  },
  {
    key: "promo-codes",
    icon: "🎁",
    label: "Promo Codes",
    title: "Promo Codes",
    description: "Create and manage discount codes and campaigns",
    path: "/portal-admin/promo-codes",
    color: "#ec4899",
    bgColor: "#fdf2f8",
    available: false,
    showInSidebar: false,
    showInDashboard: true,
  },
  {
    key: "demo-data-reset",
    icon: "🧹",
    label: "Demo Data Reset",
    title: "Demo Data Reset",
    description: "Purge demo data while retaining core platform configuration",
    path: "/portal-admin/demo-data-reset",
    color: "#64748b",
    bgColor: "#f8fafc",
    isDemoOnly: true,
    showInSidebar: true,
    showInDashboard: false,
  },
];

export const getPortalAdminTools = ({ showDemoTools = false, userRoles = [] } = {}) => {
  const normalizedRoles = Array.isArray(userRoles) ? userRoles : [];
  const isPortalAdmin = normalizedRoles.includes("R6") || normalizedRoles.includes("portal_admin");
  const isSupportAgentOnly =
    (normalizedRoles.includes("R8") || normalizedRoles.includes("support_agent")) &&
    !isPortalAdmin;

  let tools = BASE_PORTAL_ADMIN_TOOLS.filter(
    (tool) => !tool.isDemoOnly || showDemoTools,
  );

  if (isSupportAgentOnly) {
    // R8 currently gets a restricted portal shell until dedicated support pages are enabled.
    tools = tools.filter((tool) => tool.key === "dashboard");
  }

  return tools;
};
